import {FC} from "react";
import {Box, BoxProps} from "@mui/material";
import {AdminHeader} from "../../../../AdminHeader";
import {makeStyles} from "tss-react/mui";
import {useApi} from "@buildwitt/shapeshift-identity";
import {IAdminUsersLessonsResponseEntry, ILocalizationEntity, IAdminUsersCoursesResponseEntry, IEntity} from "@buildwitt/shapeshift-types";
import {AdminTable, AdminTableProps} from "@/components/common/table";
import {useNavigate} from "react-router-dom";
import {convertSecondsToHHMMSS} from "../../../../../../utils";
import {GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid-pro";
import { IBaseSearchDTO } from "@/components/common/table/AdminTable";

const useStyles = makeStyles()((theme) => ({
	contentBox: {
		marginTop: theme.spacing(3),
		padding: theme.spacing(2.5),
		backgroundColor: theme.palette.background.paper,
		borderWidth: theme.borderWidth.small,
		borderColor: theme.palette.grey[100],
		borderStyle: "solid",
		borderRadius: theme.borderRadius.small
	},
	lessonsAdminTable: {
		padding: 0,
		border: 0
	}
}));

interface ICustomProps {
	courseId: number,
	course?: IAdminUsersCoursesResponseEntry
}

export type IProps = Omit<BoxProps, "children"> & ICustomProps;

const headCells = (locales?: ILocalizationEntity[]): AdminTableProps<"lesson", IAdminUsersLessonsResponseEntry>["columns"] => ([
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		type: "string",
		hideable: false
	},
	{
		field: "title",
		type: "string",
		flex: 1,
		headerName: "Title",
		minWidth: 240
	},
	{
		field: "videoDuration",
		type: "string",
		flex: 1,
		headerName: "Duration",
		valueGetter: (e) => e.value ? convertSecondsToHHMMSS(e.value) : ""
	},
	{
		field: "updatedAt",
		type: "string",
		flex: 1,
		headerName: "Last Modified",
		valueGetter: (e) => e.value ? new Date(e.value).toLocaleDateString() : ""
	},
	{
		field: "languages",
		type: "string",
		flex: 1,
		headerName: "Supported Languages",
		valueGetter: ({value}: {value: IAdminUsersLessonsResponseEntry["languages"]}) => value?.map(e => locales?.find(x => x.code === e)?.name)?.join(", ")
	}
]);


export const LessonsTab:FC<IProps> = ({courseId,course, ...baseProps}) => {
	const {classes} = useStyles();
	const [locales] = useApi<ILocalizationEntity[]>("/api/settings/i18n");
	const navigate = useNavigate();

	return <Box {...baseProps}>
		<Box className={classes.contentBox}>
			<AdminHeader title={`${course?.title} Lessons`} />
			<AdminTable<"lesson", IAdminUsersLessonsResponseEntry, IBaseSearchDTO<IEntity> & {extendedAccess?: boolean}>
				className={classes.lessonsAdminTable}
				searchDTOverride={() => ({extendedAccess: true})}
				url={"/api/strapi-plugin-shapeshift-lms/cohort/course/" + courseId + "/lessons"}
				columns={headCells(locales.data)}
				onEditAction={e => navigate(e.id.toString())}
				type="lesson"
			/>
		</Box>
	</Box>
}